import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import {connect} from 'react-redux';
import '../sass/footer.scss';
interface configObject {
  configReducer: {
    siteConfig: {
      styles: {
        logo: string;
        pageTitle: string;
      };
    };
  };
}
interface propiedades {
  logo: string;
  pageTitle: string;
}

const Footer = (props: propiedades) => {
  return (
    <footer>
      <div className="background-secondary text-center color-primary">
        <Container className="pb-3 pt-3">
          <Row>
            <Col className="h4"> ¿Necesitás ayuda? </Col>
          </Row>
          <Row>
            <Col>Estamos para ayudarte ayuda@wehealthy.com</Col>
          </Row>
        </Container>
      </div>
      <div className="background-primary text-white text-center">
        <Container className="pb-3 pt-3">
          {`Copyright © 2023 ${props.pageTitle} - `}
          <img src={props.logo} alt="logo" className="footer-logo" />
        </Container>
      </div>
    </footer>
  );
};

const mapStateToProps = (state: configObject) => {
  return {
    pageTitle: state.configReducer.siteConfig.styles.pageTitle,
    logo: state.configReducer.siteConfig.styles.logo,
  };
};
export default connect(mapStateToProps)(Footer);
